/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BuildingHomeIcon16Light } from './BuildingHomeIcon16Light';
import { BuildingHomeIcon16Regular } from './BuildingHomeIcon16Regular';
import { BuildingHomeIcon16Solid } from './BuildingHomeIcon16Solid';
import { BuildingHomeIcon20Light } from './BuildingHomeIcon20Light';
import { BuildingHomeIcon20Regular } from './BuildingHomeIcon20Regular';
import { BuildingHomeIcon20Solid } from './BuildingHomeIcon20Solid';
import { BuildingHomeIcon24Regular } from './BuildingHomeIcon24Regular';
import { BuildingHomeIcon24Solid } from './BuildingHomeIcon24Solid';
import { BuildingHomeIcon32Regular } from './BuildingHomeIcon32Regular';
import { BuildingHomeIcon64Regular } from './BuildingHomeIcon64Regular';
var sizes = {
    16: {
        light: BuildingHomeIcon16Light,
        regular: BuildingHomeIcon16Regular,
        solid: BuildingHomeIcon16Solid,
    },
    20: {
        light: BuildingHomeIcon20Light,
        regular: BuildingHomeIcon20Regular,
        solid: BuildingHomeIcon20Solid,
    },
    24: {
        regular: BuildingHomeIcon24Regular,
        solid: BuildingHomeIcon24Solid,
    },
    32: {
        regular: BuildingHomeIcon32Regular,
    },
    64: {
        regular: BuildingHomeIcon64Regular,
    },
};
export var BuildingHomeIcon = forwardRef('BuildingHomeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
